import makeList from './makeList.js'

let viewFloor = '地震計室'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '地震計室入口',
        file: './data/I22a.JPG',
        rotation: 67.05809957126333,
        link: [
          {
            file: './data/I22.jpeg',
            position: [ -4834.152817048155, 581.4799003685063, -1104.8712953307383 ],
          },
          {
            file: './data/I22b.JPG',
            position: [ 2697.367552549264, 1144.530648098516, -4042.830843033524 ],
          },
          {
            file: './data/I22c.JPG',
            position: [ 3404.039214491258, 707.8145083784374, -3582.8297247231253 ],
          },
          {
            file: './data/I22d.JPG',
            position: [ 1963.3529217641244, 683.5477823547157, -4541.3635224543805 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 303.95913154533844, 89.39974457215831 ],
          syowaZoom: [ 476.92307692307696, 274.5384615384618 ],
        },
      },
      { description: '地震計室',
        file: './data/I22b.JPG',
        rotation: -38.058362205545706,
        link: [
          {
            file: './data/I22a.JPG',
            position: [ -3669.2284044429407, 201.0020378241619, 3380.995524544829 ],
          },
          {
            file: './data/I22c.JPG',
            position: [ 1243.7344947589168, 812.3010340053667, 4766.1908681387995 ],
          },
          {
            file: './data/I22d.JPG',
            position: [ -4772.240233288168, 492.0342346536123, -1376.77940920474 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 303.95913154533844, 89.39974457215831 ],
          syowaZoom: [ 423.0769230769231, 195.05128205128221 ],
        },
      },
      { description: '長周期地震計室',
        file: './data/I22c.JPG',
        rotation: -2.9246294511362407,
        link: [
          {
            file: './data/I22b.JPG',
            position: [ -1476.490327151581, 2260.8179455313752, -4203.17894386341 ],
          },
          {
            file: './data/I22a.JPG',
            position: [ -3440.7234487083474, 2074.4449408345017, -2963.4977164200095 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 303.95913154533844, 89.39974457215831 ],
          syowaZoom: [ 366.6666666666667, 264.2820512820515 ],
        },
      },
      { description: '水素メーザー室',
        file: './data/I22d.JPG',
        rotation: 161.7767631268599,
        link: [
          {
            file: './data/I22b.JPG',
            position: [ 4736.811416760362, -915.0091052145973, -1274.5528327615532 ],
          },
          {
            file: './data/I22a.JPG',
            position: [ 4630.260121832152, -1692.9659637409216, -773.6794163355877 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 303.95913154533844, 89.39974457215831 ],
          syowaZoom: [ 512.8205128205128, 225.82051282051304 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
